/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ImageMetadataValidationError = {
  altText?: string | undefined;
};

/** @internal */
export const ImageMetadataValidationError$inboundSchema: z.ZodType<
  ImageMetadataValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  altText: z.string().optional(),
});
/** @internal */
export type ImageMetadataValidationError$Outbound = {
  altText?: string | undefined;
};

/** @internal */
export const ImageMetadataValidationError$outboundSchema: z.ZodType<
  ImageMetadataValidationError$Outbound,
  z.ZodTypeDef,
  ImageMetadataValidationError
> = z.object({
  altText: z.string().optional(),
});

export function imageMetadataValidationErrorToJSON(
  imageMetadataValidationError: ImageMetadataValidationError,
): string {
  return JSON.stringify(
    ImageMetadataValidationError$outboundSchema.parse(
      imageMetadataValidationError,
    ),
  );
}
export function imageMetadataValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<ImageMetadataValidationError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ImageMetadataValidationError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ImageMetadataValidationError' from JSON`,
  );
}
